var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_411_2193",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_411_2193",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACbklEQVR4nO2dvW7UQBgAXSGQQEQiBQ0t1NRIQEFPAxQRLwANJeVdA6Lmp0CIIgVvgRBC4RHyDBENEERBN8jChBDdj71e37d3nqlzF++Md73e5qpKREREREREjgDuAZ+BQ2AfeAKc/vcXMhjAhNl8As4O95+lAqYspp4V51QVI98IBcg3QgHyjVCAfCMUIN8IfQAekw93RykYoQCMsFnPg79vzB5bBEd42vkCpMq5HO3rszq6q6cBM+Fw9AH4X+SqI+yNOgCzBa4ywp1qrLBY3CoiTKqxQjthzwZ8MCu/JUNEUH5HckZQfiI5Iii/J30iKD8TKbujTp/ZKMh7bpM0E0YLw8g3QgHyjVCAfCMUIN8IBcg3QgHya9znB6L8QJQfiPIDUX4gyg9E+YEoPxDlB6L8QJQfiPIDUb7yA/BUMxDlB6L8QJQfiPIDUX4gyg9E+cEAp4DLwF1gF/i2wpeuafT4iwPYAt4oP5iBI0yjx7cuM+G78gMB3mUOMIkcz9oB3M8ofxo9nrUDuJpJ/iR6LGsJsA388s7PALADXEv87CXgNvAW+OqykybxOfAjNcKx7znfcovqmn9C3PtGTO8INUsiKP8kwMExQTlmwtacYwvlz5B1YYaon8DNnhF23e20E3V9zlLRaybw5wcTvPNbiHqwYL1OngnAleY73OcvEfViQYDkmQCccc1vJ+rDkgBZngkyB+BLiwBGGPA4oQvOhJwANzoGMEJOgIcJAYyQC+BlR/EHzbFFfXa0k+1CxgrwcY7o+lRzD3gNPAJuARejr3fjaH7Sr96GvmpeyOpnwnb0dYmIiIiIiIiIiFSF8xsUI1PgrGd/ewAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.a3284d10afd193f267ba75165708454f.svg";
export { ForwardRef as ReactComponent };